import "./_functions";
import "./_components";
import "./components/currency";
import "./components/select";
import {setHeightOfHeader, toggleMenu} from "./_components";
import {addClass, removeClass, toggleClass} from "./_vars";
import {croppText} from "./components/cropped-text";
import {accordionToggle} from "./components/accordion";
import {showLabels} from "./components/cardShowLabels";
import {openFilter} from "./components/filter";
import {
    addReview,
    reviewReadMore,
    submitRecallForm,
} from "./components/reviews";
import {likedCard} from "./components/liked";
import {takeTabs} from "./components/takeTabs";
import {langSwitcher} from "./components/lang";
import "./components/map"
import "./components/articles"
/*import Swiper from "swiper";*/
import Swiper, {EffectFade, Navigation, Pagination, Thumbs} from "swiper";
import Swal from 'sweetalert2';

window.csrfToken = document.querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

document.addEventListener("DOMContentLoaded", () => {



    const fbIvent = () => {
        if (typeof fbq !== "undefined") {
            fbq('track', 'Lead');
            console.log('Event send...')
        }
        return true;
    }

    var linkToggle = document.querySelectorAll('.js-toggle');
    for (let i = 0; i < linkToggle.length; i++) {
        linkToggle[i].style.cursor = 'pointer';

        linkToggle[i].addEventListener('click', function (event) {
            event.preventDefault();
            var container = document.getElementById(this.dataset.container);
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                linkToggle[i].classList.add('--active');

                container.style.height = 'auto';
                var height = container.clientHeight + 'px';
                container.style.height = '0px';
                setTimeout(function () {
                    container.style.height = height;
                }, 0);
            } else {
                container.style.height = '0px';
                container.addEventListener('transitionend', function () {
                    container.classList.remove('active');
                    linkToggle[i].classList.remove('--active');
                }, {
                    once: true
                });
            }
        });

    }


    const mainPageAlert = document.querySelector('[data-target="alert_on_main_page"]');
    if (mainPageAlert) {
        setTimeout(function () {
            let fadeEffect = setInterval(function () {
                if (!mainPageAlert.style.opacity) {
                    mainPageAlert.style.opacity = 1;
                }
                if (mainPageAlert.style.opacity > 0) {
                    mainPageAlert.style.opacity -= 0.1;
                } else {
                    clearInterval(fadeEffect);
                    mainPageAlert.remove();
                }
            }, 200);
        }, 5000)
    }


    const openContactsButtons = document.querySelectorAll('[data-target="manager-phone"]');
    if (openContactsButtons.length) {
        openContactsButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                let objectType = button.getAttribute('data-object_type');
                let objectId = button.getAttribute('data-id');
                fbIvent();
                fetch(`/open-contact/${objectType}/${objectId}`);
            })

        });
    }
    const openMessengersButtons = document.querySelectorAll('[data-target="manager-messengers"]');
    if (openMessengersButtons.length) {
        openMessengersButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                let objectType = button.getAttribute('data-object_type');
                let objectId = button.getAttribute('data-id');
                fbIvent();
                fetch(`/open-messenger/${objectType}/${objectId}`);
            })

        });
    }

    const contactsButton = document.querySelectorAll('[data-target="contacts_button"]');
    contactsButton.forEach((button) => {
        button.addEventListener('click', function (evt) {
            fbIvent();
        });
    });

    toggleMenu();
    setHeightOfHeader();
    croppText();
    accordionToggle(".accordion");
    showLabels();
    openFilter();
    reviewReadMore();
    addReview();
    submitRecallForm();
    likedCard();
    takeTabs();
    langSwitcher();
    window.changeCurrency(window.selectedCurr)

    const heroFormMoreBtn = document.querySelectorAll(
        ".hero-form__header-right"
    );
    const heroFormBottom = document.querySelector(".hero-form__bottom");
    if (heroFormBottom) {
        heroFormMoreBtn.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                // e.preventDefault();
                toggleClass(heroFormBottom, "show");
            });
        });
    }

    const apartmentOrderCall = document.querySelector(
        ".conditions-contacts__call"
    );
    const apartmentCallModal = document.querySelector(".manager");
    const apartmentCloseModal = document.querySelector(".manager__close");
    const callShowPhone = document.querySelector(".manager__show");
    const callPhone = document.querySelector(".manager__phone");
    if (apartmentOrderCall) {
        apartmentOrderCall.addEventListener("click", () => {
            addClass(apartmentCallModal, "--show");
        });
        if (apartmentCloseModal)
            apartmentCloseModal.addEventListener("click", () => {
                removeClass(apartmentCallModal, "--show");
                addClass(callShowPhone, "--show");
                removeClass(callPhone, "--show");
            });
        if (apartmentCallModal)
            apartmentCallModal.addEventListener("click", (e) => {
                if (e.target.classList.contains("manager")) {
                    removeClass(apartmentCallModal, "--show");
                    addClass(callShowPhone, "--show");
                    removeClass(callPhone, "--show");
                }
            });
        if (callShowPhone)
            callShowPhone.addEventListener("click", () => {
                removeClass(callShowPhone, "--show");
                addClass(callPhone, "--show");
            });
    }
    const itemSubmenu = document.querySelector(".--submenu > a");
    const submenu = document.querySelector(".submenu");
    if (window.innerWidth >= 1000) {
        itemSubmenu.addEventListener("click", (e) => {
            e.preventDefault();
            toggleClass(submenu, "--show");
            toggleClass(itemSubmenu, "--active");
        });
    }

    const singleTabsButtons = document.querySelectorAll('[data-single_tabs_button]');
    const singleTabs = document.querySelectorAll('[data-single_tabs]')
    const flatsGroup = document.querySelectorAll('[data-flats_group]');
    if (singleTabsButtons.length) {
        singleTabsButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                singleTabsButtons.forEach(function (h) {
                    h.classList.remove('--active');
                });
                button.classList.add('--active');
                let tabId = button.getAttribute('data-tab_key');
                /*if (singleTabs.length) {
                    singleTabs.forEach(function (tab) {
                        tab.style.display = 'none';
                        if (tab.getAttribute('data-tab_id') === tabId || tabId === 'all')
                            tab.style.display = 'block'
                    });
                }*/
                if (flatsGroup.length) {
                    flatsGroup.forEach(function (fg) {
                        fg.style.display = 'none';
                        if (fg.getAttribute('data-flats_group') === tabId || tabId === 'all')
                            fg.style.display = 'block'
                    });
                }


            })
        });
    }

    const loadMoreNewsButton = document.querySelector('[data-target_news_more]');
    if (loadMoreNewsButton) {
        loadMoreNewsButton.addEventListener('click', function (e) {
            e.preventDefault();

            let url = loadMoreNewsButton.getAttribute('data-url');
            let totalPages = parseInt(loadMoreNewsButton.getAttribute('data-total_pages'));
            let targetPage = parseInt(loadMoreNewsButton.getAttribute('data-target_page'));

            fetch(url + targetPage, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            }).then((response) => response.text())
                .then((html) => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, 'text/html');
                    let container = document.querySelector('.news__grid');
                    doc.querySelectorAll('article').forEach(function (a) {
                        container.appendChild(a);
                    });
                    targetPage = targetPage + 1;
                    if (targetPage > totalPages)
                        loadMoreNewsButton.style.display = 'none';
                    else
                        loadMoreNewsButton.setAttribute('data-target_page', targetPage);

                });

        })
    }


    const complexLocationLoadMoreButton = document.querySelector('[data-target="more_complexes"]');
    if (complexLocationLoadMoreButton) {
        complexLocationLoadMoreButton.addEventListener('click', function (e) {
            e.preventDefault();
            const complexLocationContainer = document.querySelector('[data-target="more_complexes_container"]');
            if (complexLocationContainer) {
                let locationId = complexLocationLoadMoreButton.getAttribute('data-location_id');
                let excludeId = complexLocationLoadMoreButton.getAttribute('data-exclude_id');
                let page = parseInt(complexLocationLoadMoreButton.getAttribute('data-need_page'));
                let totalPages = parseInt(complexLocationLoadMoreButton.getAttribute('data-total_pages'));

                fetch(`/complex/load-more/` + page + '/' + locationId + '/' + excludeId, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                }).then((response) => response.text())
                    .then((html) => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(html, 'text/html');

                        let elems = doc.querySelectorAll('article');
                        if (elems.length) {
                            elems.forEach(function (elem) {
                                complexLocationContainer.appendChild(elem);
                                let slider = elem.querySelector('.card-slider');
                                if (slider) {
                                    new Swiper(slider, {
                                        slidesPerView: 1,
                                        speed: 1000,
                                        effect: "fade",
                                        nested: true,
                                        pagination: {
                                            el: elem.querySelector(
                                                ".card-slider__pagination.swiper-pagination"
                                            ),
                                            type: "bullets",
                                            clickable: true,
                                        },
                                        navigation: {
                                            nextEl: slider.querySelector(".card-slider__next"),
                                            prevEl: slider.querySelector(".card-slider__prev"),
                                        },
                                    });
                                }
                            })
                        }
                        page = page + 1;
                        if (totalPages < page)
                            complexLocationLoadMoreButton.style.display = "none";
                        else
                            complexLocationLoadMoreButton.setAttribute('data-need_page', page);

                    });
            }

        })
    }

    const contactForms = document.querySelectorAll('[data-target="contact-form"]');
    if (contactForms.length) {
        contactForms.forEach(function (elem) {
            elem.addEventListener('submit', function (e) {
                e.preventDefault();

                try {
                    let $type = elem.querySelector('input[name="type"]');
                    if ($type && ($type.value === 'flat' || $type.value === 'complex'))
                        fbIvent();
                } catch (e) {
                    console.error(e);
                }


                fetch(elem.action, {method: 'post', body: new FormData(elem)})
                    .then((response) => response.json())
                    .then((json) => {
                        Swal.fire({
                            icon: json.status,
                            //title: 'Oops...',
                            text: json.message,
                            //footer: '<a href="">Why do I have this issue?</a>'
                        })
                        if (json.status === 'success')
                            elem.reset();

                    });


            });
        });
    }

    const likedPage = document.getElementById('liked-page');
    if (likedPage) {

        let likedStorage = localStorage.getItem('liked');
        if (likedStorage !== null) {
            let liked = JSON.parse(likedStorage);

            if (liked.length) {
                let url = window.location.href;

                fetch(window.location.href, {
                    body: likedStorage,
                    method: 'POST',

                    headers: {
                        'X-CSRF-TOKEN': csrfToken,
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                }).then((response) => response.text())
                    .then((html) => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(html, 'text/html');

                        let elems = doc.querySelectorAll('article');
                        /*document.getElementById('elem-grid').innerHTML = html;*/
                        let likedGrid = document.getElementById('elem-grid');
                        if (elems.length) {
                            elems.forEach(function (elem) {
                                likedGrid.appendChild(elem);
                                let slider = elem.querySelector('.card-slider');
                                if (slider) {
                                    new Swiper(slider, {
                                        slidesPerView: 1,
                                        speed: 1000,
                                        effect: "fade",
                                        nested: true,
                                        pagination: {
                                            el: elem.querySelector(
                                                ".card-slider__pagination.swiper-pagination"
                                            ),
                                            type: "bullets",
                                            clickable: true,
                                        },
                                        navigation: {
                                            nextEl: slider.querySelector(".card-slider__next"),
                                            prevEl: slider.querySelector(".card-slider__prev"),
                                        },
                                    });
                                }
                            })
                        }
                        likedCard(likedGrid);


                    });
            } else {
                let notLiked = document.getElementById('liked-not-found')
                if (notLiked)
                    notLiked.style.display = 'block';
            }


        }

    }
});
